import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
export default {
  name: "p-head-btns",
  computed: {
    ...walletVuex.mapState(["isMobile", "address", "netId", "btnWalletLoading"])
  },
  data() {
    return {
      pWalletMenuShow: false,
      walletIcon: null
    };
  },
  methods: {
    ...walletVuex.mapActions(["doConnect"]),
    async web3Connect() {
      this.web3Wallet.connect();
    }
  }
};